import { env } from 'utils/env';

export const errorLogger = {
	dsn: env.APP_ERROR_LOG_DSN,
	environment: env.APP_ERROR_LOG_ENVIRONMENT || 'dev',
	tracesSampleRate: +env.APP_ERROR_LOG_SAMPLE_RATE || 0,
};
